import { useEffect, useState } from "react";
import { SelectOption } from "@/shared/ui/Select/Select";
import { downloadFileApi } from "@/features/player/api/download";

interface UseAudioOptionsProps {
    audioUrl: string;
    lang: string;
}

const audioOptions: SelectOption[] = [
    {
        value: "https://fastapi.dev.torsunov.pro/download_rus?file_name=01ba5e1e28b1449bbc71d7ef98a3fed0/files_to_send/1.mp3",
        label: "first audio",
    },
];

export const useAudioOptions = ({ audioUrl, lang }: UseAudioOptionsProps) => {
    const [audioFile, setAudioFile] = useState<string | null>(null);
    const [isAudioLoaded, setIsAudioLoaded] = useState(false);

    useEffect(() => {
        const loadAudio = async () => {
            if (!audioUrl) return;
            setIsAudioLoaded(false);
            try {
                console.log("audioUrl", audioUrl);
                const blob = await downloadFileApi(audioUrl);
                console.log("Тип blob:", blob.type); // тоже должен быть audio/...
                console.log("Размер blob:", blob.size);
                const fixedBlob = new Blob([blob], { type: "audio/mpeg" });
                const objectURL = URL.createObjectURL(fixedBlob);
                setAudioFile(objectURL);
                setIsAudioLoaded(true);
            } catch (error) {
                console.error("Ошибка загрузки аудио:", error);
                setIsAudioLoaded(false);
            }
        };

        loadAudio();
    }, [audioUrl, lang]);

    return { audioFile, isAudioLoaded, audioOptions };
};
